import Vue from "vue";
import Vuex from "vuex";
import statusService from "@/services/status";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    status: {},
  },
  mutations: {
    saveStatus: (state, data) => {
      state.status = data;
    },
  },
  actions: {
    loadStatus: async ({ commit }, slug) => {
      const status = await statusService.load(slug);
      console.log("loadStatus received:", status);
      commit("saveStatus", status.data);
    },
  },
  modules: {},
  getters: {
    data: (state) => state.status,
    attributes: (state) => state.status.attributes,
    monitors: (state) => state.status.relationships.monitors.data,
  },
});
